export enum SyncDirection {
  IMPORT = 'IMPORT',
  EXPORT = 'EXPORT',
}
